import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { DisabledDetailsState, LinkAccountState } from '@platform-frontend/account';
import { ClickCallbackLink } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT } from '../account-ui-matomo-events';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-deactivated-account-ui',
  templateUrl: './deactivated-account-ui.component.html',
  styleUrls: ['./deactivated-account-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class DeactivatedAccountUiComponent {
  constructor(private store: Store) {}

  @Output()
  cancelMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  reactivateMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  createAccountMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  signOutMethod: EventEmitter<void> = new EventEmitter();

  @Input()
  showCancelButton: boolean = true;

  @Input()
  showSignOutButtons: boolean = true;

  accountIdLinked$: Observable<boolean> = this.store.select(LinkAccountState.accountIdLinked);
  deleteDate$: Observable<Date | null> = this.store.select(DisabledDetailsState.deleteDate);
  upcomingPayment$: Observable<boolean> = this.store.select(DisabledDetailsState.upcomingPayment);

  readonly MATOMO_EVENT_CATEGORY_ACCOUNT = ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT;
  readonly cancelLink: ClickCallbackLink = {
    onClick: () => this.cancel(),
    class: 'link link-secondary link-underline',
    trackingEvent: {
      category: this.MATOMO_EVENT_CATEGORY_ACCOUNT,
      action: 'Select_UpdateTermsAndPrivacy',
      name: 'Cancel'
    },
    id: '8fe0af3e-b0e2-44fa-a567-b10701da4152'
  };
  readonly signOutLink: ClickCallbackLink = {
    onClick: () => this.signOut(),
    class: 'link link-secondary link-underline',
    trackingEvent: {
      category: this.MATOMO_EVENT_CATEGORY_ACCOUNT,
      action: 'Select_UpdateTermsAndPrivacy',
      name: 'SignOut'
    },
    id: '3e867a73-b94c-4159-b6bc-677bee3d1498'
  };
  readonly createAccountLink: ClickCallbackLink = {
    onClick: () => this.createAccount(),
    class: 'link link-secondary link-underline',
    trackingEvent: {
      category: this.MATOMO_EVENT_CATEGORY_ACCOUNT,
      action: 'Select_UpdateTermsAndPrivacy',
      name: 'CreateNewAccount'
    },
    id: '11e817b4-4a4f-4e7b-a136-422f7fbe961f'
  };

  cancel(): void {
    this.cancelMethod.emit();
  }

  reactivate(): void {
    this.reactivateMethod.emit();
  }

  createAccount(): void {
    this.createAccountMethod.emit();
  }

  signOut(): void {
    this.signOutMethod.emit();
  }
}
